const apiClient = require('../graphql/apiClient')
const { hideRadarArea, isViewEnabled, initialisePage, hideLoader, getRootContent } = require('../utils/headers')
const { getCellColor, getTableHeadingRow, prettifyMovementName } = require('../utils/formattingUtils')

const _ = require('lodash')

const { gql } = require('graphql-tag')

const RECENT_MOVEMENTS_QUERY = gql`
  query recentMovements($last: Int, $statuses: [Status]) {
    blips(statuses: $statuses) {
      id
      name
      link
      labels
      quadrant {
        name
      }
      updated
      reporter
      history(last: $last) {
        movement
        status
      }
    }
  }
`

const VIEW_MODE = 'movers'

function renderView() {
  if (isViewEnabled(VIEW_MODE)) {
    hideRadarArea()

    initialisePage('Movers', 'Blips that have moved since the <a href="/?view=publications">last published version</a>')

    var bodyText = ''

    apiClient(RECENT_MOVEMENTS_QUERY, {
      last: 2,
      statuses: ["CORE", "ADOPT", "TRIAL", "ASSESS", "HOLD", "OFF_RADAR"]
    })
      .then((res) => res.json())
      .then((result) => {
        const data = result.data.blips
        const sortedData = _.sortBy(data, ['quadrant.name', 'name'])
        const groupedBlips = _(sortedData)
          .groupBy((blip) => blip.quadrant.name)
          .value()

        bodyText += '<table>'
        bodyText += getTableHeadingRow(groupedBlips)
        bodyText += '<tr>'

        let colorIndex = 0

        _.map(groupedBlips, function (value) {
          bodyText += `<td style="background-color: ${getCellColor(colorIndex)};">`

          var anyMovements = false
          _.each(value, function (blip) {
            if (blip.history[1].movement != 'NO_CHANGE' && blip.history[0].status != null) {
              bodyText += `<div>
                <a href="${blip.link}" target="_blank">${blip.id}</a>: ${blip.name}<br />
                <div style="margin-left: 5px;">
                  <font size="2">
                    <div><strong>Movement: </strong><i>${movementSummary(blip)}</i></div>
                    <div><strong>Updated on: </strong><i>${new Date(blip.updated).toDateString()}</i></div>
                    <div><strong>Labels: </strong><i>${blip.labels.join(", ")}</i></div>
                  </font>
                </div>
              </div><br />`
              anyMovements = true
            }
          })

          if (!anyMovements) {
            bodyText += '<div>No blip movements found in this period...</div>'
          }

          colorIndex += 1
          bodyText += '</td>'
        })

        bodyText += '</tr></table>'
      })
      .then(() => {
        hideLoader()
        getRootContent().append('div').attr('id', 'radar-table').append('div').attr('id', 'movers-blips').html(bodyText)
      })
  }
}

function movementSummary(blip) {
  var summary = prettifyMovementName(blip.history[1].movement)

  if (blip.history[1].movement == 'NEW') {
    summary += ` (${blip.history[1].status})`
  } else {
    summary += ` from ${blip.history[0].status} to ${blip.history[1].status} `
  }
  return summary
}

module.exports = renderView
